<!--
 * @FileDescription: 动态表单单项
 * @Author: 朱建波
 * @Date: 2024-05-21
 * @LastEditors: 朱建波 342393950@qq.com
 *
 * @name: ZDynamicFormItem
 *
 * @Props
 * @property {Object} form                 表单数据对象
 * @property {Object} item                  表单每项的参数
 *
 * @Slots
 *
 * @Methods
-->
<script>
const asyncComponent = (tag) => {
  return () => import(`@/components/common/${tag}.vue`)
}
const Uploads = () => ({
  component: import('@/components/common/Uploads.vue'),
  // loading: Uploads,
  // error: Uploads,
  delay: 200,
  timeout: 3000
})
export default {
  name: 'ZDynamicFormItem',
  components: { Uploads },
  props: {
    form: { type: Object, default: () => ({}) },
    item: { type: Object, default: () => ({}) },
  },
  computed: {
    span() {
      const { span } = this.item
      return span || 24
    },
    tag() {
      const { prop, tag } = this.item
      if(!prop) return ''
      return tag || 'input'
    },
    newLabel() {
      const { label = '', vPlaceholder } = this.item
      let val = label
      if (vPlaceholder && vPlaceholder.length) {
        vPlaceholder.forEach(i => {
          // const { symbol, change = '', key, value } = i
          // const dataValue = this.form[key]
          // const Func = new Function(`return ${dataValue} ${symbol} ${value}`)
          // const flag = Func()
          const { change = '' } = i
          const flag = this.evaluateCondition(i)
          if (flag && change) {
            val = change
            this.item.isClear && (this.form[this.item.prop] = '')
          }
        })
      }
      return val
    },
    placeholder() {
      const { placeholder } = this.item
      if(placeholder) return placeholder
      if(['select', 'date'].includes(this.tag)) return '请选择'
      return '请输入'
    },
    options() {
      const { options = [], tag, prop } = this.item
      const whiteArr = ['radio', 'checkbox', 'select']
      if (!whiteArr.includes(tag)) return []
      let isCanClear = false
      const arr = options.map(i => {
        const { vIf = [], ...other } = i
        if (!vIf.length) return { ...other, flag: true }
        isCanClear = true
        let flag = false
        vIf.map(j => {
          const isOk = this.evaluateCondition(j)
          if (isOk) flag = true
        })
        return { ...other, flag }
      })
      const list = arr.filter(i => i.flag)

      if (isCanClear) {
        let isClear = true
        list.some(i => {
          if (this.form[prop] === i.value) {
            isClear = false
          }
        })
        if (isClear) {
          this.form[prop] = tag === 'checkbox' ? [] : ''
        }
      }
      return list
    }
  },
  watch: {
    item: {
      handler() {
        this.changeShow()
      },
      deep: true,
      immediate: true
    },
    form: {
      handler() {
        this.changeShow()
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    evaluateCondition(condition){
      const { key, value, symbol = '=' } = condition;
      const dataValue = this.form[key]
      switch(symbol) {
        case '=':
        case '==':
        case '===':
          return dataValue === value;
        case '>':
          return dataValue > value;
        case '<':
          return dataValue < value;
        case '>=':
          return dataValue >= value;
        case '<=':
          return dataValue <= value;
        case '!==':
          return dataValue !== value;
        default:
          return false;
      }
    },
    handleFileChange(arr, key) {
      this.form[key] = arr
      this.item.change && this.item.change(arr)
    },
    changeShow() {
      if (this.item.hide) {
        this.show = false
        return
      }
      const arr = this.item.vIf
      if (arr && arr.length) {
        let flag = false
        arr.forEach(i => {
          const isOk = this.evaluateCondition(i)
          if (isOk) flag = true
        })
        this.show = flag
      } else {
        this.show = true
      }
    }
  }
}
</script>

<template>
  <el-col :span="span" v-if="show">
    <el-form-item :class="{ 'is-single': item.isSingle}" :label="newLabel" :prop="item.prop" :label-width="item.labelWidth">
      <!-- 自定义插槽 -->
      <template v-if="item.slotName">
        <slot :name="item.slotName">{{ item.slotName }}插槽未用</slot>
      </template>
      <!-- 嵌套组件 -->
      <template v-else-if="item.children">
        <ZDynamicFormItem :form="form" :item="child" v-for="child in item.children" :key="child.prop">
          <template v-for="slot in Object.keys($slots)" #[slot]><slot :name="slot" /></template>
        </ZDynamicFormItem>
      </template>
      <template v-else-if="tag === 'span'">{{ item.value }}</template>
      <!-- prop属性缺失 -->
      <template v-else-if="!tag">prop属性缺失</template>
      <!-- 设置标签类型 -->
      <template v-else-if="tag === 'select'">
        <el-select v-model="form[item.prop]" :placeholder="placeholder" v-bind="item.custom" @change="item.change ? item.change($event) : false">
          <el-option :label="third.label" :value="third.value" :disabled="third.disabled" v-for="third in options" :key="third.value"></el-option>
        </el-select>
      </template>
      <template v-else-if="tag === 'input'">
        <el-input v-model="form[item.prop]" resize="none" :type="item.type || 'text'" :maxlength="item.maxlength" :placeholder="placeholder" v-bind="item.custom" @change="item.change ? item.change($event) : false"></el-input>
      </template>
      <template v-else-if="tag === 'date'">
        <el-date-picker v-model="form[item.prop]" :type="item.type || 'date'" :placeholder="placeholder" v-bind="{'value-format': 'yyyy-MM-dd',...item.custom}" @change="item.change ? item.change($event) : false"></el-date-picker>
      </template>
      <template v-else-if="tag === 'radio'">
        <el-radio-group v-model="form[item.prop]">
          <template v-if="item.type === 'button'">
            <el-radio-button v-for="third in options" :label="third.value" :disabled="third.disabled" :key="third.value">{{ third.label }}</el-radio-button>
          </template>
          <template v-else>
            <el-radio v-for="third in options" :label="third.value" :disabled="third.disabled" :key="third.value">{{ third.label }}</el-radio>
          </template>
        </el-radio-group>
      </template>
      <template v-else-if="tag === 'checkbox'">
        <el-checkbox-group v-model="form[item.prop]">
          <template v-if="item.type === 'button'">
            <el-checkbox-button v-for="third in options" :label="third.value" :disabled="third.disabled" :key="third.value">{{ third.label }}</el-checkbox-button>
          </template>
          <template v-else>
            <el-checkbox v-for="third in options" :label="third.value" :disabled="third.disabled" :key="third.value">{{ third.label }}</el-checkbox>
          </template>
        </el-checkbox-group>
      </template>
      <template v-else-if="tag === 'upload'">
        <Uploads :list="form[item.prop]" v-bind="item.custom" @change="handleFileChange($event, item.prop)"></Uploads>
      </template>
      <!-- 未定义标签类型 -->
      <template v-else>
        <span>tag标签错误</span>
      </template>
    </el-form-item>
  </el-col>
</template>

<style lang="scss" scoped></style>
